class BasicTexBlanks {
  constructor(root) {
    this.root = root;
    this.data = JSON.parse(root.querySelector('[data-btb-product-json]').textContent);
    this.selectedPack = 3;
    this.galleryImage = root.querySelector('.btb-gallery-main img');
    this.configList = root.querySelector('[data-btb-config-list]');
    this.buyButton = root.querySelector('[data-btb-buy]');
    this.mobileBuy = root.querySelector('[data-btb-mobile-buy]');
    this.copyButton = root.querySelector('[data-btb-copy-all]');
    this.error = root.querySelector('[data-btb-error]');
    this.bindGallery();
    this.bindPacks();
    this.bindBuyButtons();
    this.bindCopyButton();
    this.selectPack(3);
  }

  bindGallery() {
    if (!this.galleryImage) return;
    this.root.querySelectorAll('[data-btb-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        this.root.querySelectorAll('[data-btb-thumb]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        this.galleryImage.style.opacity = '0';
        window.setTimeout(() => {
          this.galleryImage.src = button.dataset.image;
          this.galleryImage.srcset = button.dataset.srcset || '';
          this.galleryImage.alt = button.dataset.alt || this.galleryImage.alt;
          this.galleryImage.style.opacity = '1';
        }, 150);
      });
    });
  }

  bindPacks() {
    this.root.querySelectorAll('[data-btb-pack]').forEach((button) => {
      button.addEventListener('click', () => this.selectPack(Number(button.dataset.qty)));
    });
  }

  selectPack(quantity) {
    this.selectedPack = quantity;
    this.root.querySelectorAll('[data-btb-pack]').forEach((button) => {
      const selected = Number(button.dataset.qty) === quantity;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    const selectedCard = this.root.querySelector(`[data-btb-pack][data-qty="${quantity}"]`);
    const price = selectedCard.dataset.price;
    const name = selectedCard.dataset.name;
    this.root.querySelectorAll('[data-btb-selected-price]').forEach((element) => { element.textContent = price; });
    this.root.querySelectorAll('[data-btb-selected-name]').forEach((element) => { element.textContent = name; });
    this.renderConfiguration(quantity);
    if (this.copyButton) this.copyButton.hidden = quantity === 1;
    this.error.textContent = '';
  }

  renderConfiguration(quantity) {
    const sizes = this.data.sizes;
    const colors = this.data.colors;
    const sizeOptions = sizes.map((size) => `<option value="${this.escape(size)}">${this.escape(size)}</option>`).join('');
    const colorOptions = colors.map((color) => `<option value="${this.escape(color)}">${this.escape(this.colorLabel(color))}</option>`).join('');
    const initialColorClass = this.colorClass(colors[0]);
    this.configList.innerHTML = Array.from({ length: quantity }, (_, index) => `
      <div class="btb-config-item" data-btb-unit>
        <span class="btb-config-item__title">Camiseta ${String(index + 1).padStart(2, '0')}</span>
        <div class="btb-select-grid">
          <div class="btb-field">
            <label for="btb-size-${this.data.sectionId}-${index}">Talla</label>
            <select id="btb-size-${this.data.sectionId}-${index}" data-btb-size>${sizeOptions}</select>
          </div>
          <div class="btb-field">
            <label for="btb-color-${this.data.sectionId}-${index}">Color</label>
            <div class="btb-choice-control">
              <span class="btb-choice-preview bg_color_${initialColorClass}" data-btb-color-preview aria-hidden="true"></span>
              <select id="btb-color-${this.data.sectionId}-${index}" data-btb-color>${colorOptions}</select>
            </div>
          </div>
        </div>
      </div>`).join('');

    this.configList.querySelectorAll('[data-btb-color]').forEach((select) => {
      this.updateColorPreview(select);
      select.addEventListener('change', () => this.updateColorPreview(select));
    });
  }

  bindBuyButtons() {
    [this.buyButton, this.mobileBuy].forEach((button) => {
      if (button) button.addEventListener('click', () => this.addPack());
    });
  }

  bindCopyButton() {
    if (!this.copyButton) return;
    this.copyButton.addEventListener('click', () => {
      const units = Array.from(this.configList.querySelectorAll('[data-btb-unit]'));
      if (units.length < 2) return;
      const size = units[0].querySelector('[data-btb-size]').value;
      const color = units[0].querySelector('[data-btb-color]').value;
      units.slice(1).forEach((unit) => {
        unit.querySelector('[data-btb-size]').value = size;
        const colorSelect = unit.querySelector('[data-btb-color]');
        colorSelect.value = color;
        this.updateColorPreview(colorSelect);
      });
      this.copyButton.textContent = 'Selección aplicada ✓';
      window.setTimeout(() => { this.copyButton.textContent = this.copyButton.dataset.label; }, 1400);
    });
  }

  normalize(value) {
    return String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }

  colorLabel(value) {
    const normalized = this.normalize(value);
    if (normalized === 'white') return 'Blanco';
    if (normalized === 'black') return 'Negro';
    if (normalized === 'blue') return 'Azul';
    if (normalized === 'red') return 'Rojo';
    if (normalized === 'pink') return 'Rosado';
    if (normalized === 'brown' || normalized === 'coffee') return 'Café';
    if (normalized === 'gray' || normalized === 'grey') return 'Gris';
    return value;
  }

  colorClass(value) {
    return this.normalize(value)
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  updateColorPreview(select) {
    const preview = select.closest('.btb-choice-control')?.querySelector('[data-btb-color-preview]');
    if (!preview) return;
    Array.from(preview.classList).filter((name) => name.indexOf('bg_color_') === 0).forEach((name) => preview.classList.remove(name));
    preview.classList.add(`bg_color_${this.colorClass(select.value)}`);
  }

  matchesColor(variantValue, chosenValue) {
    const variant = this.normalize(variantValue);
    const chosen = this.normalize(chosenValue);
    const groups = [['white', 'blanco'], ['black', 'negro']];
    return variant === chosen || groups.some((group) => group.includes(variant) && group.includes(chosen));
  }

  findVariant(size, color) {
    return this.data.variants.find((variant) => {
      const sizeMatch = this.normalize(variant.options[this.data.sizeIndex]) === this.normalize(size);
      const colorMatch = this.matchesColor(variant.options[this.data.colorIndex], color);
      return sizeMatch && colorMatch;
    });
  }

  async addPack() {
    const units = Array.from(this.configList.querySelectorAll('[data-btb-unit]'));
    const selected = units.map((unit) => ({
      size: unit.querySelector('[data-btb-size]').value,
      color: unit.querySelector('[data-btb-color]').value
    }));
    const resolved = selected.map((choice) => ({ ...choice, variant: this.findVariant(choice.size, choice.color) }));
    const missing = resolved.find((item) => !item.variant || !item.variant.available);
    if (missing) {
      this.error.textContent = `La combinación ${missing.size} / ${this.colorLabel(missing.color)} no está disponible. Elige otra opción.`;
      return;
    }

    const grouped = new Map();
    resolved.forEach((item) => {
      const key = String(item.variant.id);
      grouped.set(key, {
        id: item.variant.id,
        quantity: (grouped.get(key)?.quantity || 0) + 1,
        properties: { 'Combo': this.selectedPack === 1 ? 'Camiseta individual' : `Pack x${this.selectedPack}` }
      });
    });

    const buttons = [this.buyButton, this.mobileBuy].filter(Boolean);
    const original = buttons.map((button) => button.textContent);
    buttons.forEach((button) => { button.disabled = true; button.textContent = 'Preparando tu pedido…'; });
    this.error.textContent = '';

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: Array.from(grouped.values()) })
      });
      if (!response.ok) throw new Error('No pudimos agregar el pedido al carrito.');
      const card = this.root.querySelector(`[data-btb-pack][data-qty="${this.selectedPack}"]`);
      const discount = card.dataset.discount;
      if (discount) {
        window.location.assign(`/discount/${encodeURIComponent(discount)}?redirect=/cart`);
      } else {
        window.location.assign('/cart');
      }
    } catch (error) {
      this.error.textContent = error.message || 'Ocurrió un error. Intenta nuevamente.';
      buttons.forEach((button, index) => { button.disabled = false; button.textContent = original[index]; });
    }
  }

  escape(value) {
    return String(value).replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
    })[character]);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-btb-product]').forEach((root) => new BasicTexBlanks(root));
});
